var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#004A80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 10.9913L12.1033 14.0625H5.0625V13.5489L8.88188 9.207L5.13956 4.4955V3.9375H12.0758L12.3176 6.32925H11.8733C11.5802 5.78419 11.3316 5.37637 11.1263 5.10581C10.9215 4.83525 10.7387 4.66706 10.5778 4.60013C10.4642 4.545 10.3078 4.50562 10.1087 4.482C9.87092 4.45583 9.63182 4.44362 9.39262 4.44544H7.42219L10.3748 8.12419V8.30138L6.72525 12.4442H10.8906C11.0953 12.4442 11.2832 12.3953 11.4531 12.2979C11.6229 12.2001 11.7703 12.0774 11.8946 11.9301C12.0252 11.7777 12.1411 11.6133 12.2406 11.439C12.3471 11.2541 12.4407 11.062 12.5207 10.8641L12.9375 10.9913Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmg);
export default __webpack_public_path__ + "static/media/xmg.275be8307c54af4ec62442c5be0508e9.svg";
export { ForwardRef as ReactComponent };